import { useAppDispatch, useAppSelector } from '@app/core/hooks/redux-hooks';
import PwcNavigate from '@app/shared/routing/PwcNavigate';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import BuildStructureControls from './build-structure-erf/controls/BuildStructureControls';
import { EventSetNavigationControls } from '../controls/EventSetNavigationControls';
import { CalcMethod } from '@app/shared/models/contracts/enums/shared-enums';
import styles from './build-structure-erf/build-structure.module.scss';
import { resetCapitalStructureCapTableSelectedEventIndex } from '@app/core/store/ui-values-slice';

interface CapitalStructureTabContentProps {
  isBuildStructure?: boolean;
}

export const CapitalStructureTabContent: FC<CapitalStructureTabContentProps> = ({
  isBuildStructure = false,
}): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const { caseId } = useParams();
  const project = useAppSelector((state) => state.project.projectDraft);
  const buildStructures = useAppSelector((state) => state.capitalStructure.values.buildStructures);
  const capitalStructureId = project.pwermInput.cases[0].capitalStructureId;
  const isErfProject = buildStructures && buildStructures?.[capitalStructureId]?.isErf;
  const isOpmOnly = project.details.calcMethod === CalcMethod.OPM;
  const reduxCaseId = useAppSelector(
    (state) => state.uiValues.userSelections.capitalStructure.buildStructure.selectedCase
  );
  const storedCaseId = project.pwermInput.cases.find((item) => item.caseId === reduxCaseId)
    ? reduxCaseId
    : caseId;
  const redirectCaseId = storedCaseId ?? caseId ?? project.pwermInput.cases[0].caseId;
  if (isErfProject && !caseId && !isOpmOnly) {
    return (
      <PwcNavigate
        route=":caseId"
        params={{
          caseId: redirectCaseId,
        }}
      />
    );
  } else if (isErfProject && isOpmOnly && caseId) {
    return <PwcNavigate route="" />;
  } else if (!isErfProject && caseId) {
    return <PwcNavigate route="" />;
  }

  const navigationControls = isBuildStructure ? (
    <BuildStructureControls />
  ) : (
    <div className={styles['controls']}>
      <EventSetNavigationControls
        resetFunction={() => dispatch(resetCapitalStructureCapTableSelectedEventIndex())}
      />
    </div>
  );

  return <>{isErfProject && !isOpmOnly && navigationControls}</>;
};
